module.exports = __webpack_public_path__ + "static/logo-payoff-18c5c894e19437a4f19ab50d061046f1.svg";